import React, { useState, useContext } from "react";
import axios from "axios";
import moment from "moment";
import DataTable from "react-data-table-component";
import { NotificationManager } from "react-notifications";
import { makeStyles } from "@mui/styles";
import LinearProgress from "@mui/material/LinearProgress";
import Tooltip from "@mui/material/Tooltip";
import EditIcon from "@mui/icons-material/Edit";
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CheckIcon from '@mui/icons-material/Check';
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import { deleteMarketMembershipClaim, downloadFile } from "services/ConfigServices";
import usePatrimoineTable from "./usePatrimoineTable.js";
import EditClaimDialog from "./EditClaimDialog";
import CustomDeleteButton from "components/CustomDeleteButton/CustomDeleteButton.js";
import UserService from "services/UserService";
import Button from "components/CustomButtons/Button.js";
import styled from "styled-components";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { columnnames } from "variables/backoffice/realestate";
import { categoryData, entitytypeData, datatypeData } from "variables/backoffice/lists/realestate";
import Dialog from "@mui/material/Dialog";
import { withStyles } from "@mui/styles";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import MarketsContext from "context/MarketsContext";
import Chip from "@mui/material/Chip";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ViewDataListDialog from "./ViewDataListDialog";

const GroupCell = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const Container = styled.div`
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.15);
  border-top: 4px solid rgba(255, 255, 255, 1);
  background-color: white;
  margin-top: -0.5px;
`;

const ExpandableContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0.5rem 4rem 2rem;
`;
const ExpandableElement = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: ${(props) => props.marginleft};
`;

const ElementTitle = styled.div`
  font-weight: 600;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
`;

const ElementData = styled.div`
  margin-left: 4px;
  font-weight: 400;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
`;

const ElementSectionTitle = styled.div`
  font-weight: 600;
  font-size: 13px;
  font-family: "Source Sans Pro",sans-serif;
  text-decoration: underline;
  margin-top: 10px;
`;

const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;

const ElementDataDownload = styled.div`
  margin-left: 4px;
  font-weight: 400;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
  cursor: pointer;
  text-decoration: underline;
`;

const CellContentNoWrap = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const ExpandableComponent = props => {
  const { data } = props;
  // const marketContext = useContext(MarketsContext);
  // const { market, setMarket } = marketContext;
  // const detailarr = data.parameters?.detail?.split("\n") || [];
  // const rejectioncausearr = data.parameters?.rejectioncause?.split("\n") || [];
  // return (
  //   <Container>
  //     <ExpandableContainer>
  //       <ElementSectionTitle>Réclamation</ElementSectionTitle>
  //       <ExpandableElement>
  //         <ElementTitle>{memberclaim.marketmembershipnumber} : </ElementTitle>
  //         <ElementData>{data.parameters?.marketmembershipnumber}</ElementData>
  //       </ExpandableElement>
  //       <ExpandableElement>
  //         <ElementTitle>{memberclaim.marketmembershipname} : </ElementTitle>
  //         <ElementData>{data.parameters?.marketmembershipname}</ElementData>
  //       </ExpandableElement>
  //       <ExpandableElement>
  //         <ElementTitle>{memberclaim.author} : </ElementTitle>
  //         <ElementData>{data.parameters?.author}</ElementData>
  //       </ExpandableElement>
  //       <ExpandableElement>
  //         <ElementTitle>{memberclaim.creationdate} : </ElementTitle>
  //         <ElementData>{data.parameters.creationdate && moment(data.parameters.creationdate).isValid()
  //           ? moment(data.parameters.creationdate).format("DD/MM/YYYY HH:mm")
  //           : ""}</ElementData>
  //       </ExpandableElement>
  //       <ExpandableElement>
  //         <ElementTitle>{memberclaim.purpose} : </ElementTitle>
  //         <ElementData>{data.parameters?.purpose}</ElementData>
  //       </ExpandableElement>
  //       <ExpandableElement>
  //         <ElementTitle>{memberclaim.detail} : </ElementTitle>
  //         <ElementData>{detailarr.map((line) => {
  //           return (
  //             <>
  //               {line}<br />
  //             </>
  //           );
  //         })
  //         }</ElementData>
  //       </ExpandableElement>
  //       <ExpandableElement>
  //         <ElementTitle>{memberclaim.amountasked} : </ElementTitle>
  //         <ElementData>{data.parameters?.amountasked && new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 2 }).format(data.parameters?.amountasked)} €</ElementData>
  //       </ExpandableElement>
  //       <ExpandableElement>
  //         <ElementTitle>{memberclaim.associatedfiles} : </ElementTitle>
  //         {data.parameters?.associatedfiles.map((file) => {
  //           return <ElementDataDownload onClick={downloadGED(file.fileId, file.fileName)}>{file.fileName}</ElementDataDownload>;
  //         })
  //         }
  //       </ExpandableElement>
  //       <ElementSectionTitle>Etat d'avancement</ElementSectionTitle>
  //       <ExpandableElement>
  //         <ElementTitle>{memberclaim.status} : </ElementTitle>
  //         <ElementData>{data.parameters?.status && <div style={{ color: memberclaimStatusData.find((x) => x.id == data.parameters.status).color, fontWeight: "bold" }}>
  //           {memberclaimStatusData.find((x) => x.id == data.parameters.status).name}</div>}
  //         </ElementData>
  //       </ExpandableElement>
  //       {
  //         data.parameters?.status === 'refused' &&
  //         <ExpandableElement>
  //           <ElementTitle>{memberclaim.rejectioncause} : </ElementTitle>
  //           <ElementData>{rejectioncausearr.map((line) => {
  //           return (
  //             <>
  //               {line}<br />
  //             </>
  //           );
  //         })
  //         }</ElementData>
  //         </ExpandableElement>
  //       }
  //       {
  //         data.parameters?.status === 'payed' &&
  //         <ExpandableElement>
  //           <ElementTitle>{memberclaim.amountreceived} : </ElementTitle>
  //           <ElementData>{data.parameters?.amountreceived && new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 2 }).format(data.parameters?.amountreceived)} €</ElementData>
  //         </ExpandableElement>
  //       }
  //       {
  //         (data.parameters?.status === 'refused' || data.parameters?.status === 'payed') &&
  //         <ExpandableElement>
  //           <ElementTitle>{memberclaim.enddate} : </ElementTitle>
  //           <ElementData>{data.parameters.enddate && moment(data.parameters.enddate).isValid()
  //             ? moment(data.parameters.enddate).format("DD/MM/YYYY hh:mm")
  //             : ""}</ElementData>
  //         </ExpandableElement>
  //       }
  //     </ExpandableContainer>
  //   </Container >
  // );
};

const downloadGED = (fileId, fileName) => async () => {
  axios
    .get(
      downloadFile(fileId),
      {
        responseType: "blob",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      }
    )
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName); //or any other extension
      document.body.appendChild(link);
      link.click();
    });
};


const useStyles = makeStyles(styles);

const RTPatrimone = () => {
  const { gridState, refetch, setSelectedClaims } = usePatrimoineTable();
  const advancedSearchContext = useContext(AdvancedSearchContext);
  const { groupInfoListById, setPage } = advancedSearchContext;
  const [open, setOpen] = useState(false);
  const [openDataList, setOpenDataList] = useState(false);
  const [openValidateClaim, setOpenValidateClaim] = useState(false);
  const [currentVariable, setCurrentVariable] = useState(null);

  let dataVariables = gridState.data;

  const classes = useStyles();

  const columns = [
    {
      name: columnnames.category,
      selector: (row) => row.category,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) => row.category ?
        <Tooltip title={categoryData.find((x) => x.id == row.category)?.name}>
          <CellContentNoWrap>{categoryData.find((x) => x.id == row.category)?.name}</CellContentNoWrap>
        </Tooltip>
        : <></>
    },
    {
      name: columnnames.request,
      selector: (row) => row.request,
      sortable: true,
      maxWidth: "10rem",
    },
    {
      name: columnnames.path,
      selector: (row) => row.path,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) =>
        <Tooltip title={row.path}>
          <CellContentNoWrap>{row.path}</CellContentNoWrap>
        </Tooltip>
    },
    {
      name: columnnames.id,
      selector: (row) => row.id,
      sortable: true,
      maxWidth: "10rem",
    },
    {
      name: columnnames.name,
      selector: (row) => row.name,
      sortable: true,
      maxWidth: "10rem",
    },
    {
      name: columnnames.entitytype,
      selector: (row) => row.entitytype,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) => row.entitytype ?
        row.entitytype.length === 1 ?
          entitytypeData.find((x) => x.id == row.entitytype[0])?.name
          :
          row.entitytype.length > 1 ?
            <Tooltip title={row.entitytype.map((entitytype) => {
              return (
                <>{entitytypeData.find((x) => x.id == entitytype)?.name} </>
              );
            })}>
              <div>{row.entitytype.length} types</div>
            </Tooltip>
            :
            <div>
              Aucun type choisi
            </div>
        : <></>
    },
    {
      name: columnnames.datatype,
      selector: (row) => row.datatype,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) => row.datatype ?
        datatypeData.find((x) => x.id == row.datatype)?.name
        : <></>
    },
    {
      name: columnnames.data,
      selector: (row) => row.data,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) => row.datatype && row.datatype === 'select' ?
        <Tooltip title="Voir les valeurs'">
          <Button
            onClick={viewDataList(row)}
            color={"info"}
            className={classes.actionButtonDense}
          >
            <VisibilityIcon fontSize="large" />
          </Button>
        </Tooltip>
        : <></>
    },
    {
      name: columnnames.description,
      selector: (row) => row.description,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) =>
        <Tooltip title={row.description}>
          <CellContentNoWrap>{row.description}</CellContentNoWrap>
        </Tooltip>
    },
    {
      name: "",
      sortable: false,
      width: "10rem",
      // eslint-disable-next-line react/button-has-type
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <>
          <div className="actions-right">
            <Tooltip title="Editer la réclamation'">
              <Button
                onClick={editVariable(row)}
                color={"warning"}
                className={classes.actionButtonDense}
              >
                <EditIcon fontSize="large" />
              </Button>
            </Tooltip>
            <Tooltip title="Supprimer la réclamation'">
              <CustomDeleteButton
                deleteTitle={"Suppression de la réclamation"}
                deleteSubTitle={`Êtes-vous sûr de vouloir supprimer la réclamation?`}
                handleSupprimer={deleteClaimFunction(row)}
                size={"28px"}
              />
            </Tooltip>
          </div>
        </>
      ),
    },
  ];

  const handleEditOpen = () => {
    setOpen(true);
  };
  const handleEditClose = () => {
    setOpen(false);
  };

  const handleDataListOpen = () => {
    setOpenDataList(true);
  };
  const handleDataListClose = () => {
    setOpenDataList(false);
  };


  const editVariable = (row) => async () => {
    let obj = dataVariables.find((o) => o.autoid === row.autoid);
    if (obj) {
      setCurrentVariable(obj);
      handleEditOpen();
    }
  }

  const viewDataList = (row) => async () => {
    let obj = dataVariables.find((o) => o.autoid === row.autoid);
    if (obj) {
      setCurrentVariable(obj);
      handleDataListOpen();
    }
  }



  const deleteClaimFunction = (row) => async () => {
    let obj = dataVariables.find((o) => o.autoid === row.autoid);
    let idSelected = obj.id;
    let url = deleteMarketMembershipClaim(idSelected);
    axios
      .delete(url, {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((res) => {
        if (res.status == 200) {
          setNotification(
            "success",
            `La réclamation a été supprimée`
          );
          refetch();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const handleSelectedRowsChange = (selection) => {
    setSelectedClaims(selection.selectedRows);
  };

  return (
    <>
      <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
        noDataComponent={<NoData>Aucune réclamation à afficher</NoData>}
        noHeader={true}
        columns={columns}
        persistTableHead
        pagination
        subHeader
        dense={true}
        progressPending={gridState.loading}
        progressComponent={<LinearProgress />}
        onSelectedRowsChange={handleSelectedRowsChange}
        selectableRows={true}
        expandOnRowClicked
        expandableRows
        expandableRowDisabled={(row) => row.disabled}
        expandableRowsComponent={ExpandableComponent}
        paginationComponentOptions={{
          noRowsPerPage: false,
          rowsPerPageText: "Lignes par page",
          rangeSeparatorText: "sur",
          selectAllRowsItem: false,
          selectAllRowsItemText: "Selectionner toutes les lignes",
        }}
        {...gridState}
      />
      <Dialog
        onClose={handleEditClose}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="sm"
        open={open}
      >
        <CustomDialogTitle id="customized-dialog-title" onClose={handleEditClose}>
          Modification de la réclamation
        </CustomDialogTitle>
        <DialogContent dividers>
          <EditClaimDialog
            claim={currentVariable}
            closeModal={handleEditClose}
            refetch={refetch}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
      <Dialog
        onClose={handleDataListClose}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="sm"
        open={openDataList}
      >
        <CustomDialogTitle id="customized-dialog-title" onClose={handleDataListClose}>
          Liste des données
        </CustomDialogTitle>
        <DialogContent dividers>
          <ViewDataListDialog
            variable={currentVariable}
            closeModal={handleDataListClose}
            refetch={refetch}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
    </>
  );
};

export default RTPatrimone;
